import { Grid } from "@mui/material";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AddEditWorker from "./AddEditWorker";
import ClientList from "./ClientList";
import WorkerList from "./WorkerList";
import MyCustomersList from "./MyCustomersList";

const tabs = [
  { label: "workersList", value: "workerList" },
  { label: "clientsList", value: "clientList" },
  { label: "myCustomersList", value: "myCustomersList" },
  // { label: "Client Reviews", value: "clientReviews" },
];

const CompanyWorkerAndClients = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, company_worker_client: tab }));
  };
  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={t("workersClients")}
            tabs={tabs}
            activeTab={activeTab.company_worker_client}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.company_worker_client === "workerList" ? (
            <WorkerList />
          ) : activeTab.company_worker_client === "clientList" ? (
            <ClientList />
          ) : activeTab.company_worker_client === "myCustomersList" ? (
            <MyCustomersList />
          ) : activeTab.company_worker_client === "add_edit_woker" ? (
            <AddEditWorker />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default CompanyWorkerAndClients;
